import { Link } from "react-router-dom";
import { movieCategories } from "@/mocks/movies";

export default function CategoryGrid() {
  return (
    <section aria-labelledby="category-entry">
      <h4
        id="category-entry"
        className="mb-4 flex items-center gap-2 font-heading text-lg font-600 tracking-wide text-foreground-950"
      >
        <span className="flex h-6 w-6 items-center justify-center text-primary-500">
          <i className="ri-apps-2-line text-[20px]" aria-hidden="true"></i>
        </span>
        影视分类快捷入口
      </h4>
      <div className="grid grid-cols-2 gap-3">
        {movieCategories.map((cat, index) => (
          <Link
            key={cat.key}
            to={`/category?category=${encodeURIComponent(cat.key)}`}
            className={`group flex flex-col rounded-lg border p-4 transition-colors ${
              index === 0
                ? "border-primary-500/40 bg-primary-500/10 hover:border-primary-500"
                : "border-background-200 bg-background-100 hover:border-accent-400"
            }`}
          >
            <span
              className={`flex h-10 w-10 items-center justify-center rounded-md ${
                index === 0 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-accent-500"
              }`}
            >
              <i className={`${cat.icon} text-[22px]`} aria-hidden="true"></i>
            </span>
            <span className="mt-3 font-500 text-foreground-950 transition-colors group-hover:text-primary-500">
              {cat.label}
            </span>
            <span className="mt-1 line-clamp-2 text-[11px] leading-relaxed text-foreground-600">
              {cat.desc}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}